<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

<div class="height-100-percent">
  @if (this.Mode === 'design') {
    <div class="flex-row-top-right">
      <div class="fill-remaining-space">
        <!-- If there are instructions, display label first, then instructions then field -->
        @if (this.HasInstructions) {
          @if (this.DisplayName) {
            <div class="design-mode-field-label">{{this.DisplayName}} @if (this.FormField.required) {
              <span style="color: #EF0000;">*</span>
            }</div>
          }
          <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
        }
        <mat-form-field appearance="outline"
          [floatLabel]="'always'" [hideRequiredMarker]="true">
          @if (this.ShowLabel && !HasInstructions) {
            <mat-label
              class="design-mode-field-label">{{this.DisplayName}} @if (this.FormField.required) {
              <span style="color: #EF0000;">*</span>
            }</mat-label>
          }
          <input matInput
            title="{{this.DisplayName}}"
            attr.aria-label="{{this.DisplayName}}"
            placeholder="{{this.PlaceholderText}}"
            [required]="this.FormField.required"
            value="{{this.DefaultValue}}"
            disabled />
          </mat-form-field>
          <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
      </div>
    }

    @if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
      <div>
          <div>
              @if ((this.ControlType === 'Reactive Forms')) {
              @if (this.FormControl !== null) {
              <!-- If there are instructions, display label first, then instructions then field -->
              @if (this.HasInstructions) {
              @if (this.DisplayName) {
              <div class="field-label">
                  {{this.DisplayName}} @if (this.FormField.required) {
                  <span style="color: #EF0000;">*</span>
                  }
              </div>
              }
              <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
              }

              <!-- If there are no instructions, display label integrated into the field -->
              @if (this.ShowLabel && !this.HasInstructions && !FieldIsInGrid) {
              <mat-label class="field-label">
                  {{this.DisplayName}} @if (this.FormField.required) {
                  <span style="color: #EF0000;">*</span>
                  }
              </mat-label>
              }
              @if (this.fieldIsInGrid) { <!--inside grid cell-->
              <div style="display: flex; align-items: center; width: 100%; gap: 3px;">
                  <div style="flex-grow: 1;">
                      <input #gridOnlyTextArea
                             class="short-text-in-grid"
                             matInput
                             title="{{this.DisplayName}} (Click icon to right to edit in a dialog)"
                             attr.aria-label="{{this.DisplayName}}"
                             [required]="this.FormField.required"
                             [readonly]="this.ReadOnly"
                             placeholder="{{this.PlaceholderText}}"
                             [formControl]="this.FormControl"
                             (blur)="this.handleOnBlur()"
                             (focus)="this.handleOnFocus($event)"
                             (keydown.enter)="this.handleEnterKey()" />
                  </div>
                  <div style="height:14pt;">
                      <mat-icon style="font-size: 14pt; color: dimgrey;" title="Click to edit in a dialog" (click)="this.handleOpenGridCellEditor($event)">open_in_new</mat-icon>
                  </div>
              </div>
              }
              @else{
                  <mat-form-field appearance="outline" [floatLabel]="'always'" [hideRequiredMarker]="true" subscriptSizing="dynamic">
                      @if(fieldIsInGridCellEditor){ <!--inside grid popup editor-->
                      <textarea matInput
                                placeholder="{{this.PlaceholderText}}"
                                [formControl]="this.FormControl"
                                [required]="this.FormField.required"
                                [attr.aria-label]="this.DisplayName"
                                rows="3"
                                (blur)="this.handleOnBlur()"
                                (focus)="this.handleOnFocus($event)"></textarea>
                      }

                      @else{ <!-- outside grid -->
                      <input matInput
                             type="text"
                             id="{{this.MatInputId}}"
                             title="{{this.DisplayName}}"
                             attr.aria-label="{{this.DisplayName}}"
                             [required]="this.FormField.required"
                             [readonly]="this.ReadOnly"
                             placeholder="{{this.PlaceholderText}}"
                             [formControl]="this.FormControl"
                             (blur)="this.handleOnBlur()"
                             (focus)="this.handleOnFocus($event)" />
                      }
                  </mat-form-field>
                  }

                  <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
                  }
                  }
              </div>
          <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
        </div>
      }
    </div>
